module.exports = __webpack_public_path__ + "3e6d08c346820ab5b250ac2dc05c8215.png";